package guide.kuki.app.engine

import kotlinx.coroutines.withTimeoutOrNull

// TEMPORARY: while names.json is in active flux, fetch the latest copy from
// kuki.guide on launch and fall back to the bundled file on failure. To
// disable: flip REMOTE_NAMES_ENABLED to false. To remove: delete this file
// and its actuals, and revert RadialMapProvider.loadNames() to read the
// bundled resource directly.
const val REMOTE_NAMES_ENABLED = true
const val REMOTE_NAMES_URL = "https://kuki.guide/assets/names.json"
private const val REMOTE_NAMES_TIMEOUT_MS = 3_000L

internal expect suspend fun platformFetchBytes(url: String): ByteArray?

suspend fun fetchRemoteNamesBytes(): ByteArray? {
    if (!REMOTE_NAMES_ENABLED) return null
    return try {
        withTimeoutOrNull(REMOTE_NAMES_TIMEOUT_MS) { platformFetchBytes(REMOTE_NAMES_URL) }
    } catch (_: Throwable) {
        null
    }
}
